<mat-toolbar [ngClass]="menuCollapsed ? 'justify-content-center' : 'justify-content-between p-2'">
  <img src="../../../favicon.ico" class="app-icon" />
  @if (!menuCollapsed) {
  <span>AUJS</span>
  }
</mat-toolbar>
@if (userLoggedIn) {
<acs-menu class="aujs-menu-directive flex-fill d-flex flex-column"></acs-menu>
} @else {
<div class="flex-fill d-flex flex-column"></div>
}

<button
  mat-button
  color="accent"
  (click)="toggleMenuCollapse()"
  class="collapse-btn"
  [ngClass]="menuCollapsed ? 'justify-content-end' : 'justify-content-start'"
>
  <fa-icon [icon]="collapsedStateIcon" class="fa fa-lg collapse-icon pr-2"></fa-icon>
  @if (!menuCollapsed) {
  <span>{{ 'acs-menu.collapse.label' | translate }}</span>
  }
</button>
